var React = require('react');

function PlayButton (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M54 108c29.823 0 54-24.177 54-54S83.823 0 54 0 0 24.177 0 54s24.177 54 54 54zM42.269 73.674 77.462 54 42.27 34.326v39.348z","fill":"red"}));
}

PlayButton.defaultProps = {"fill":"none","viewBox":"0 0 108 108"};

module.exports = PlayButton;

PlayButton.default = PlayButton;
